/**
 * A long text a model wrote without any line break reads better in short
 * paragraphs (two sentences each). Used by the chats of the analyst and the Forge.
 */
export const toReadableMarkdown = (content: string): string => {
  if (content.includes('\n') || content.length < 240) return content;
  // A sentence ends with . ! ? (or a closing quote) followed by a space and a capital: « dominoflow.com » stays whole.
  const sentences = content.split(/(?<=[.!?»])\s+(?=[A-ZÀ-ÝÉ«])/).map((sentence) => sentence.trim()).filter(Boolean);
  const paragraphs: string[] = [];
  for (let index = 0; index < sentences.length; index += 2) paragraphs.push(sentences.slice(index, index + 2).join(' '));
  return paragraphs.join('\n\n');
};
